import React from "react";
import { StyledFullTextLink } from "./_styled";

const actionKey = [13, 32];

export default function usePmidLinkProcessor(options) {
  const { openFtfDialog } = options;

  const processPmidLink = (node, children) => {
    const dataTitle = node.attribs["data-title"];
    const links = children?.map((child) => {
      return {
        targetUrl: child?.props?.["href"],
        linkName: child?.props?.["children"],
      };
    });

    const doAction = () => {
      openFtfDialog(node.attribs["data-value"], "pmid", links);
    };

    const handleKeyDown = (event) => {
      if (actionKey.includes(event.keyCode)) {
        doAction();
      }
    };

    return (
      <>
        <StyledFullTextLink
          onClick={doAction}
          onKeyDown={handleKeyDown}
          data-testid="pmid-ftlink-button"
        >
          {dataTitle}
        </StyledFullTextLink>
      </>
    );
  };

  return { processPmidLink };
}
